export const nullIfEmpty = (text?: string | null): string | null => {
  return !text || text.trim() === '' ? null : text;
};
